<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import '@/assets/js/bootstrap.js';
export default {
  name: "App"
};
</script>

<style lang="css">
@import './assets/css/Style.css';
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'; 
</style>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue